<template>
<div>
    <div class="panel panel-default panel-wntable" 
        v-if="playerRows.length > 0">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $_locale('reservations') }}</h3>
        </div>
        <div class="panel-body" style="padding: 0;">
            <wn-table-pages 
                :items="playerRows">
                <template #head>
                    <th style="min-width: 65px;"></th>
                    <th>{{ $_locale('order number') }}</th>
                    <th>{{ $_locale('created') }}</th>
                    <th>{{ $_locale('orderer') }}</th>
                    <th>{{ $_locale('player') }}</th>
                    <th>{{ $_locale('tee time') }}</th>
                </template>
                <template v-slot="{ item: row }">
                    <tr :key="row.reservationTimeId">
                    <td>
                        <button class="btn btn-xs btn-default"
                            @click="selectReservation(row.reservation, row.player)">
                            <i class="glyphicon glyphicon-pencil"></i>
                        </button>
                        <button class="btn btn-xs btn-danger" 
                            @click="deactivateReservationTime(row.reservation.reservationTimeId)">
                            <i class="glyphicon glyphicon-trash"></i>
                        </button>
                    </td>
                    <td>
                        <a v-bind:href="orderLinkUrl(row.reservation.orderId)" target="_blank">
                            {{ row.reservation.orderId }}
                        </a>
                    </td>
                    <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.reservation.dateCreated) }}</td>
                    <td>{{ row.reservation.firstName }} {{ row.reservation.lastName }}</td>
                    <td>{{ row.player.firstName }} {{ row.player.familyName }}</td>
                    <td>
                        {{ $_formatDateTime($_dateFormat.DATETIME_HI, row.reservation.start) }}
                    </td>
                    </tr>
                </template>
            </wn-table-pages>
        </div>
    </div>
    <div class="panel panel-default panel-wntable" 
        v-if="disabledTimes.length > 0">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $_locale('disabled times') }}</h3>
        </div>
        <div class="panel-body" style="padding: 0;">
            <wn-table-pages 
                :items="disabledTimes">
                <template #head>
                    <th style="min-width: 65px;"></th>
                    <th>{{ $_locale('order number') }}</th>
                    <th>{{ $_locale('created') }}</th>
                    <th>{{ $_locale('handler') }}</th>
                    <th>{{ $_locale('time') }}</th>
                </template>
                <template v-slot="{ item: row }">
                    <tr :key="row.reservationTimeId">
                    <td>
                        <button class="btn btn-xs btn-default"
                            @click="selectReservation(row)">
                            <i class="glyphicon glyphicon-pencil"></i>
                        </button>
                        <button class="btn btn-xs btn-danger" 
                            @click="deactivateReservationTime(row.reservationTimeId)">
                            <i class="glyphicon glyphicon-trash"></i>
                        </button>
                    </td>
                    <td>
                        <a v-bind:href="orderLinkUrl(row.orderId)" target="_blank">
                            {{ row.orderId }}
                        </a>
                    </td>
                    <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.dateCreated) }}</td>
                    <td>{{ row.firstName }} {{ row.lastName }}</td>
                    <td>
                        {{ $_formatDateTime($_dateFormat.DATETIME_HI, row.start) }}
                        -
                        {{ $_formatDateTime($_dateFormat.DATETIME_HI, row.end) }}
                    </td>
                    </tr>
                </template>
            </wn-table-pages>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        reservation: {
            type: Object,
            required: true,
            default: {}
        },
        cacheActiveReservation: {
            type: Boolean,
            default: true,
        }
    }, // reservation block from reservationservice
    computed: {
        ...mapGetters({
            orderLinkUrl: 'ecom/orderLinkUrl',
            reservationPlayers: 'golf/reservationPlayers',
            date: 'reservations/date',
        }),
        disabledTimes() {
            return this.reservation.reservations.filter(row => [4,5].indexOf(row.status) > -1)
        },
        playerRows() {
            return this.reservation.reservations.reduce((acc, curr) => {
                const players = this.getReservationPlayers(curr.reservationTimeId);
                const playerRows = players.map(row => ({
                    player: row,
                    reservation: curr
                }));

                return [
                    ...acc,
                    ...playerRows,
                ]
            }, []);
        },
    },
    methods: {
        getReservationPlayers(reservationTimeId) {
            const players = this.reservationPlayers.filter(
                row => row.reservationTimeId == reservationTimeId
            )

            return players;
        },
        selectReservation(reservation, player = null) {
            const block = { 
                ...this.reservation.block
            }

            if ([2,3].indexOf(reservation.status) > -1) {
                const status = reservation.isCart ? _locale('in cart').ucfirst() : _locale('reserved').ucfirst();
                block.info =  `${ status }: ${ player.firstName } ${ player.familyName } (${ reservation.firstName } ${ reservation.lastName })`;
            }
            
            if ([4,5].indexOf(reservation.status) > -1) {
                block.info = _locale('time disabled').ucfirst();
            }
            
            this.$store.commit('calendar/setEditReservation', { block, reservation, cacheActiveReservation: this.cacheActiveReservation })
            this.$emit('selected')
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('common/setModal', null);
                    
                    EcomService.deactivateReservationTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                this.$store.dispatch('reservations/onDateChange', this.date);
                                
                                this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                            } else {
                                this.$_swal({ icon: 'error', title: data.message })
                            }
                        })
                }
            })
        },
    }
}
</script>
